export default {
  // 搜索相关
  searchPlaceholder: "搜索地址/哈希/调证用户ID",
  dataDetails: "数据详情",

  // 页面标题
  transactionDetails: "交易详情",

  // 按钮
  joinCanvas: "加入画布",
  browserView: "浏览器查看",
  addRemark: "点击添加备注",
  reset: "重置",
  query: "查询",
  downloadDetails: "下载数据明细",

  // 交易信息
  sender: "发送方",
  receiver: "接收方",
  interactor: "交互方",
  smartContract: "智能合约",
  transactionTime: "交易时间",
  transactionAmount: "交易数量",
  transactionFee: "交易手续费",

  // 表格相关
  tokenTransfer: "代币转账",
  senderAddress: "发送方地址",
  receiverAddress: "接收方地址",
  pleaseSelect: "请选择",
  currency: "币种",
  amount: "数量",

  // 加载和状态
  loading: "拼命加载中",
  noData: "暂无数据",

  // 消息提示
  addressNotFound: "没有查出该地址",

  // 下载文件名
  dataDetailsFileName: "数据明细",

  // 数据统计
  totalDataPrefix: "共计",
  totalDataSuffix: "条数据",
  downloadLimit: "注：最多可下载1万条数据",

  // 备注
  note: "备注:",
};
